/* eslint-disable @typescript-eslint/no-explicit-any */
export default function pipe(...fns: any[]) {
  return (x: any) => fns.reduce((v, f) => f(v), x);
}
